"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Menu, Phone } from "lucide-react";
import { siteConfig } from "@/config/site";

interface MobileNavProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileNav({ isOpen, onOpenChange }: MobileNavProps) {
  const handleLinkClick = () => {
    onOpenChange(false);
  };

  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange}>
      <DrawerTrigger asChild>
        <Button variant="ghost" size="icon" className="lg:hidden">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </DrawerTrigger>
      <DrawerContent className="h-[85vh]">
        <div className="mx-auto w-full max-w-sm p-6">
          <nav className="flex flex-col space-y-6 mt-4">
            <Link
              href="/"
              className="text-xl font-medium hover:text-primary transition-colors text-center py-2"
              onClick={handleLinkClick}
            >
              Home
            </Link>
            <Link
              href="#about"
              className="text-xl font-medium hover:text-primary transition-colors text-center py-2"
              onClick={handleLinkClick}
            >
              About Nicholas
            </Link>
            <Link
              href="#services"
              className="text-xl font-medium hover:text-primary transition-colors text-center py-2"
              onClick={handleLinkClick}
            >
              Services
            </Link>
            <Link
              href="#process"
              className="text-xl font-medium hover:text-primary transition-colors text-center py-2"
              onClick={handleLinkClick}
            >
              Process
            </Link>
            <Link
              href="#contact"
              className="text-xl font-medium hover:text-primary transition-colors text-center py-2"
              onClick={handleLinkClick}
            >
              Contact
            </Link>
            <div className="pt-6 space-y-3">
              <Button className="w-full h-12 text-lg" asChild>
                <a href={siteConfig.contact.phoneHref}>
                  <Phone className="mr-2 h-5 w-5" />
                  Call: {siteConfig.contact.phone}
                </a>
              </Button>
              <Button variant="outline" className="w-full h-12 text-lg" asChild>
                <Link href="#contact" onClick={handleLinkClick}>
                  Get Free Quote
                </Link>
              </Button>
            </div>
          </nav>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
